module.exports = __webpack_public_path__ + "img/制御工学7_10.ef05dd03.png";